// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}
ion-header::after {
  display: none;
}
ion-header ion-toolbar {
  --background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-background-color));
  --border-width: 0 0 1px 0;
  --border-color: var(--ion-color-light-shade);
}
ion-header ion-toolbar ion-title {
  font-weight: 600;
}

.form-close-icon {
  margin-left: 0.5rem;
  font-size: 1.7rem;
}

ion-footer {
  box-shadow: none;
  background: var(--ion-background-color);
}
ion-footer::before {
  display: none;
}

.footer-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-top: 1px solid var(--ion-color-light-shade);
}
.footer-bar ion-spinner {
  margin: 12px auto;
}
.footer-bar .footer-btn {
  width: 100%;
  max-width: 480px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-grid ion-item {
  --min-height: 48px;
  --padding-start: 8px;
  --inner-padding-end: 4px;
}
.form-grid ion-note[slot=helper] {
  font-size: 0.72rem;
  line-height: 1.2;
  margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.form-grid ion-card {
  margin: 0;
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 8px;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-background-color));
}
.form-grid ion-card-header {
  padding: 10px 14px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid var(--ion-color-light-shade);
  background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-card-background, var(--ion-background-color)));
}
.form-grid ion-card-content {
  padding: 12px 14px;
}
.form-grid ion-card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ion-text-color);
}
.form-grid ion-card-subtitle {
  margin-top: 2px;
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--ion-color-medium);
  text-transform: none;
  letter-spacing: normal;
}
.form-grid .toggle-helper {
  display: block;
  font-size: 0.72rem;
  margin: -2px 0 8px 12px;
  line-height: 1.15;
}
.form-grid .lock-note {
  display: block;
  font-size: 0.72rem;
  margin: -4px 0 8px;
}
.form-grid .advanced-sections {
  margin: 0;
}
.form-grid .advanced-sections ion-accordion {
  margin-bottom: 6px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--ion-color-light-shade);
}
.form-grid .advanced-sections ion-accordion ion-item[slot=header] {
  --background: linear-gradient(
    180deg,
    var(--ion-color-light-tint),
    var(--ion-card-background, var(--ion-background-color))
  );
  --min-height: 44px;
  font-weight: 600;
}
.form-grid .advanced-sections ion-accordion ion-item[slot=header] ion-icon {
  color: var(--ion-color-primary);
}
.form-grid .advanced-sections ion-accordion [slot=content] {
  padding: 8px 10px 10px;
}
.form-grid .advanced-sections.inner {
  margin: 6px 0 2px;
}
.form-grid .advanced-sections.inner ion-accordion {
  border: 1px dashed var(--ion-color-light-shade);
}
.form-grid .advanced-sections.inner ion-accordion ion-item[slot=header] {
  --background: transparent;
  --min-height: 38px;
  font-weight: 500;
  font-size: 0.85rem;
}
.form-grid .accordion-hint {
  font-size: 0.78rem;
  color: var(--ion-color-medium);
  margin: 4px 8px 8px;
}
.form-grid .cards-row-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 900px) {
  .form-grid .cards-row-2 {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
}
.form-grid .fields-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .form-grid .fields-row-2 {
    grid-template-columns: 1fr;
  }
}
.form-grid .fields-row-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px 8px;
}
@media (max-width: 600px) {
  .form-grid .fields-row-3 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 400px) {
  .form-grid .fields-row-3 {
    grid-template-columns: 1fr;
  }
}
.form-grid .address-grid {
  display: grid;
  grid-template-columns: 1fr 100px 80px;
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .form-grid .address-grid {
    grid-template-columns: 1fr 1fr;
  }
  .form-grid .address-grid > ion-item:last-child {
    grid-column: 1/-1;
  }
}
.form-grid .config-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
}
.form-grid .config-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.form-grid .config-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--ion-color-medium);
}
.form-grid .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  color: var(--ion-color-medium);
}
.form-grid .empty-state ion-icon {
  font-size: 2rem;
  opacity: 0.45;
}
.form-grid .empty-state p {
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
  max-width: 28ch;
  text-wrap: balance;
}

.fields-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .fields-row {
    grid-template-columns: 1fr;
  }
}

.tipo-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.tipo-grid .tipo-item {
  --min-height: 40px;
  --padding-start: 8px;
}

.sede-form {
  border-radius: 8px;
  border: 1px solid var(--ion-color-primary-tint);
  background: color-mix(in srgb, var(--ion-color-primary) 6%, transparent);
  padding: 16px;
  margin-bottom: 16px;
}
.sede-form .sede-form-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ion-color-primary);
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sede-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .sede-fields-grid {
    grid-template-columns: 1fr;
  }
}

.sedi-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  color: var(--ion-color-medium);
}
.sedi-empty ion-icon {
  font-size: 2rem;
  opacity: 0.4;
}
.sedi-empty p {
  font-size: 0.875rem;
  margin: 0;
}

.sedi-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sede-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--ion-color-light-shade);
  background: var(--ion-card-background, var(--ion-background-color));
  transition: border-color 0.15s;
}
.sede-row:hover {
  border-color: var(--ion-color-medium-tint);
}

.sede-info {
  flex: 1;
  min-width: 0;
}

.sede-name-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.sede-codice {
  font-family: var(--ion-font-family-monospace, monospace);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}

.sede-nome {
  font-size: 0.875rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sede-address,
.sede-contacts {
  font-size: 0.75rem;
  color: var(--ion-color-medium);
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sede-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.sede-action-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.1s;
  background: transparent;
}
.sede-action-btn:active {
  transform: scale(0.95);
}

.sede-action-edit {
  color: var(--ion-color-primary);
  background: color-mix(in srgb, var(--ion-color-primary) 10%, transparent);
}
.sede-action-edit:hover {
  background: color-mix(in srgb, var(--ion-color-primary) 18%, transparent);
}

.sede-action-delete {
  color: var(--ion-color-danger);
  background: color-mix(in srgb, var(--ion-color-danger) 10%, transparent);
}
.sede-action-delete:hover {
  background: color-mix(in srgb, var(--ion-color-danger) 18%, transparent);
}`, "",{"version":3,"sources":["webpack://./src/theme/_form-modal.scss","webpack://./src/app/_components/anagrafiche/anagrafica-create/anagrafica-create.component.scss"],"names":[],"mappings":"AAgBA;EACE,gBAAA;ACfF;ADiBE;EAAW,aAAA;ACdb;ADgBE;EACE,+FAAA;EACA,yBAAA;EACA,4CAAA;ACdJ;ADgBI;EACE,gBAAA;ACdN;;ADmBA;EACE,mBAAA;EACA,iBAAA;AChBF;;ADqBA;EACE,gBAAA;EACA,uCAAA;AClBF;ADoBE;EAAY,aAAA;ACjBd;;ADoBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kDAAA;ACjBF;ADmBE;EACE,iBAAA;ACjBJ;ADoBE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AClBJ;;ADwBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACrBF;ADyBE;EACE,kBAAA;EACA,oBAAA;EACA,wBAAA;ACvBJ;AD2BE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;ACzBJ;AD8BE;EACE,SAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;EACA,mEAAA;AC5BJ;AD+BE;EACE,kBAAA;EACA,0BAAA;EACA,qDAAA;EACA,yHAAA;AC7BJ;ADoCE;EACE,kBAAA;AClCJ;ADqCE;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;ACnCJ;ADsCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;ACpCJ;ADyCE;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;ACvCJ;AD0CE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;ACxCJ;AD6CE;EACE,SAAA;AC3CJ;AD6CI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC3CN;AD8CI;EACE;;;;GAAA;EAKA,kBAAA;EACA,gBAAA;AC5CN;AD8CM;EAAW,+BAAA;AC3CjB;AD8CI;EACE,sBAAA;AC5CN;ADgDI;EACE,iBAAA;AC9CN;ADgDM;EACE,+CAAA;AC9CR;ADiDM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AC/CR;ADoDE;EACE,kBAAA;EACA,8BAAA;EACA,mBAAA;AClDJ;ADuDE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;ACrDJ;ADuDI;EALF;IAMI,8BAAA;IACA,kBAAA;ECpDJ;AACF;ADuDE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;ACrDJ;ADuDI;EALF;IAMI,0BAAA;ECpDJ;AACF;ADuDE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;ACrDJ;ADuDI;EALF;IAMI,8BAAA;ECpDJ;AACF;ADsDI;EATF;IAUI,0BAAA;ECnDJ;AACF;ADsDE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;ACpDJ;ADsDI;EALF;IAMI,8BAAA;ECnDJ;EDqDI;IACE,iBAAA;ECnDN;AACF;ADyDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;ACvDJ;AD0DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;ACxDJ;AD2DE;EACE,mBAAA;EACA,gBAAA;EACA,8BAAA;ACzDJ;AD8DE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,8BAAA;AC5DJ;AD8DI;EACE,eAAA;EACA,aAAA;AC5DN;AD+DI;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AC7DN;;AA9NA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAiOF;AA/NE;EALF;IAMI,0BAAA;EAkOF;AACF;;AA7NA;EACE,aAAA;EACA,qCAAA;AAgOF;AA9NE;EACE,kBAAA;EACA,oBAAA;AAgOJ;;AA1NA;EACE,kBAAA;EACA,+CAAA;EACA,wEAAA;EACA,aAAA;EACA,mBAAA;AA6NF;AA3NE;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AA6NJ;;AAzNA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AA4NF;AA1NE;EALF;IAMI,0BAAA;EA6NF;AACF;;AAxNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,8BAAA;AA2NF;AAzNE;EACE,eAAA;EACA,YAAA;AA2NJ;AAxNE;EACE,mBAAA;EACA,SAAA;AA0NJ;;AApNA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAuNF;;AApNA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,8CAAA;EACA,mEAAA;EACA,8BAAA;AAuNF;AArNE;EACE,0CAAA;AAuNJ;;AAnNA;EACE,OAAA;EACA,YAAA;AAsNF;;AAnNA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAsNF;;AAnNA;EACE,wDAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,cAAA;AAsNF;;AAnNA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsNF;;AAnNA;;EAEE,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsNF;;AAnNA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAsNF;;AAnNA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kDAAA;EACA,uBAAA;AAsNF;AApNE;EACE,sBAAA;AAsNJ;;AAlNA;EACE,+BAAA;EACA,yEAAA;AAqNF;AAnNE;EACE,yEAAA;AAqNJ;;AAjNA;EACE,8BAAA;EACA,wEAAA;AAoNF;AAlNE;EACE,wEAAA;AAoNJ","sourcesContent":["// ════════════════════════════════════════════════════════════════════════════\n// Stile condiviso modali \"create\" — form GitHub-style\n// Importato da: ordine-vendita-create, anagrafica-create, articoli-prodotti-create\n//\n// Linguaggio visivo: card con bordi sottili 1px, niente ombra, arrotondamenti\n// leggeri (8px), header con sfumatura grigio neutro + separatore, informazioni\n// ben chiare. Tutto token-driven (--ion-color-*, --ion-card-background, ...) →\n// il dark mode si adatta da solo (token ridefiniti in body.dark).\n//\n// Le regole interne al form sono scopate sotto `.form-grid` (presente in tutte e\n// tre le modali) per vincere con certezza sulle regole `:host` di Ionic.\n// Toolbar e footer stanno fuori da `.form-grid` → regole a livello radice.\n// ════════════════════════════════════════════════════════════════════════════\n\n// ─── Header del modale (toolbar con sfumatura neutra) ────────────────────────\n\nion-header {\n  box-shadow: none;\n\n  &::after { display: none; } // rimuove l'ombra md di default\n\n  ion-toolbar {\n    --background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-background-color));\n    --border-width: 0 0 1px 0;\n    --border-color: var(--ion-color-light-shade);\n\n    ion-title {\n      font-weight: 600;\n    }\n  }\n}\n\n.form-close-icon {\n  margin-left: 0.5rem;\n  font-size: 1.7rem;\n}\n\n// ─── Footer del modale ───────────────────────────────────────────────────────\n\nion-footer {\n  box-shadow: none;\n  background: var(--ion-background-color);\n\n  &::before { display: none; } // rimuove l'ombra md di default\n}\n\n.footer-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border-top: 1px solid var(--ion-color-light-shade);\n\n  ion-spinner {\n    margin: 12px auto;\n  }\n\n  .footer-btn {\n    width: 100%;\n    max-width: 480px;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n  }\n}\n\n// ─── Contenuto form ──────────────────────────────────────────────────────────\n\n.form-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  // ── Compattazione campi ───────────────────────────────────────────────────\n\n  ion-item {\n    --min-height: 48px;\n    --padding-start: 8px;\n    --inner-padding-end: 4px;\n  }\n\n  // Helper leggibile su massimo 2 righe (niente troncamento a 1 riga)\n  ion-note[slot=\"helper\"] {\n    font-size: 0.72rem;\n    line-height: 1.2;\n    margin-top: 2px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  // ── Card \"Box\" GitHub-style ───────────────────────────────────────────────\n\n  ion-card {\n    margin: 0;\n    border: 1px solid var(--ion-color-light-shade);\n    border-radius: 8px;\n    box-shadow: none;\n    background: var(--ion-card-background, var(--ion-background-color));\n  }\n\n  ion-card-header {\n    padding: 10px 14px;\n    border-radius: 8px 8px 0 0;\n    border-bottom: 1px solid var(--ion-color-light-shade);\n    background: linear-gradient(\n      180deg,\n      var(--ion-color-light-tint),\n      var(--ion-card-background, var(--ion-background-color))\n    );\n  }\n\n  ion-card-content {\n    padding: 12px 14px;\n  }\n\n  ion-card-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: var(--ion-text-color);\n  }\n\n  ion-card-subtitle {\n    margin-top: 2px;\n    font-size: 0.75rem;\n    font-weight: 400;\n    color: var(--ion-color-medium);\n    text-transform: none;     // override del maiuscoletto Ionic → leggibilità\n    letter-spacing: normal;\n  }\n\n  // ── Helper inline (toggle / lock) ─────────────────────────────────────────\n\n  .toggle-helper {\n    display: block;\n    font-size: 0.72rem;\n    margin: -2px 0 8px 12px;\n    line-height: 1.15;\n  }\n\n  .lock-note {\n    display: block;\n    font-size: 0.72rem;\n    margin: -4px 0 8px;\n  }\n\n  // ── Accordion sezioni avanzate ────────────────────────────────────────────\n\n  .advanced-sections {\n    margin: 0;\n\n    ion-accordion {\n      margin-bottom: 6px;\n      border-radius: 8px;\n      overflow: hidden;\n      border: 1px solid var(--ion-color-light-shade);\n    }\n\n    ion-accordion ion-item[slot=\"header\"] {\n      --background: linear-gradient(\n        180deg,\n        var(--ion-color-light-tint),\n        var(--ion-card-background, var(--ion-background-color))\n      );\n      --min-height: 44px;\n      font-weight: 600;\n\n      ion-icon { color: var(--ion-color-primary); }\n    }\n\n    ion-accordion [slot=\"content\"] {\n      padding: 8px 10px 10px;\n    }\n\n    // Accordion annidati (es. \"Indirizzo dettagliato\", \"U.M. aggiuntiva\")\n    &.inner {\n      margin: 6px 0 2px;\n\n      ion-accordion {\n        border: 1px dashed var(--ion-color-light-shade);\n      }\n\n      ion-accordion ion-item[slot=\"header\"] {\n        --background: transparent;\n        --min-height: 38px;\n        font-weight: 500;\n        font-size: 0.85rem;\n      }\n    }\n  }\n\n  .accordion-hint {\n    font-size: 0.78rem;\n    color: var(--ion-color-medium);\n    margin: 4px 8px 8px;\n  }\n\n  // ── Griglie responsive condivise ──────────────────────────────────────────\n\n  .cards-row-2 {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n\n    @media (min-width: 900px) {\n      grid-template-columns: 1fr 1fr;\n      align-items: start;\n    }\n  }\n\n  .fields-row-2 {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 4px 8px;\n\n    @media (max-width: 480px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .fields-row-3 {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4px 8px;\n\n    @media (max-width: 600px) {\n      grid-template-columns: 1fr 1fr;\n    }\n\n    @media (max-width: 400px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .address-grid {\n    display: grid;\n    grid-template-columns: 1fr 100px 80px;\n    gap: 4px 8px;\n\n    @media (max-width: 480px) {\n      grid-template-columns: 1fr 1fr;\n\n      > ion-item:last-child {\n        grid-column: 1 / -1;\n      }\n    }\n  }\n\n  // ── Blocco configurazione (toggle stato record) ───────────────────────────\n\n  .config-block {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-top: 12px;\n  }\n\n  .config-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .config-label {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n  }\n\n  // ── Empty / info state ────────────────────────────────────────────────────\n\n  .empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 32px 16px;\n    color: var(--ion-color-medium);\n\n    ion-icon {\n      font-size: 2rem;\n      opacity: 0.45;\n    }\n\n    p {\n      font-size: 0.875rem;\n      margin: 0;\n      text-align: center;\n      max-width: 28ch;\n      text-wrap: balance;\n    }\n  }\n}\n","@use '../../../../theme/form-modal' as *;\n\n// Stile specifico della modale anagrafica.\n// Il \"chrome\" condiviso (card Box-style, header sfumato, accordion, footer,\n// compattazione campi, accordion-hint) arriva dal partial _form-modal.scss.\n\n// ─── Side-by-side fields (IVA + CF, contatti, ...) ──────────────────────────\n\n.fields-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 8px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n// ─── Tipo checkboxes: 2-column grid ─────────────────────────────────────────\n\n.tipo-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n\n  .tipo-item {\n    --min-height: 40px;\n    --padding-start: 8px;\n  }\n}\n\n// ─── Sede form ───────────────────────────────────────────────────────────────\n\n.sede-form {\n  border-radius: 8px;\n  border: 1px solid var(--ion-color-primary-tint);\n  background: color-mix(in srgb, var(--ion-color-primary) 6%, transparent);\n  padding: 16px;\n  margin-bottom: 16px;\n\n  .sede-form-title {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--ion-color-primary);\n    margin: 0 0 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n}\n\n.sede-fields-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 4px 8px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n// ─── Empty state ─────────────────────────────────────────────────────────────\n\n.sedi-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  color: var(--ion-color-medium);\n\n  ion-icon {\n    font-size: 2rem;\n    opacity: 0.4;\n  }\n\n  p {\n    font-size: 0.875rem;\n    margin: 0;\n  }\n}\n\n// ─── Sede list items ─────────────────────────────────────────────────────────\n\n.sedi-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sede-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--ion-color-light-shade);\n  background: var(--ion-card-background, var(--ion-background-color));\n  transition: border-color 0.15s;\n\n  &:hover {\n    border-color: var(--ion-color-medium-tint);\n  }\n}\n\n.sede-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.sede-name-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.sede-codice {\n  font-family: var(--ion-font-family-monospace, monospace);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--ion-color-primary);\n  flex-shrink: 0;\n}\n\n.sede-nome {\n  font-size: 0.875rem;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sede-address,\n.sede-contacts {\n  font-size: 0.75rem;\n  color: var(--ion-color-medium);\n  margin: 2px 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sede-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.sede-action-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s, transform 0.1s;\n  background: transparent;\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.sede-action-edit {\n  color: var(--ion-color-primary);\n  background: color-mix(in srgb, var(--ion-color-primary) 10%, transparent);\n\n  &:hover {\n    background: color-mix(in srgb, var(--ion-color-primary) 18%, transparent);\n  }\n}\n\n.sede-action-delete {\n  color: var(--ion-color-danger);\n  background: color-mix(in srgb, var(--ion-color-danger) 10%, transparent);\n\n  &:hover {\n    background: color-mix(in srgb, var(--ion-color-danger) 18%, transparent);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
